import React, { Component } from "react";
import NavigationOverviewLinkList from "ReactComponents/NavigationOverview/navigation-overview-link-list";

class NavigationOverview extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="navigation-overview-container content-module">
                {this.props.NavigationSections &&
                    this.props.NavigationSections.map((item, index) => {
                        return <NavigationOverviewLinkList key={index} {...item} />;
                    })}
            </div>
        );
    }
}
export default NavigationOverview;
